import React from 'react';

export function FilterPanel({ titleVisible = true, children }) {
    return (
        <div className="filters-area flex-row">
            {titleVisible && <div className="margin-r-8 text-sm">Filters:</div>}
            {children}
        </div>
    )
}
